import { createFileRoute, Link } from "@tanstack/react-router";
import { absoluteUrl } from "@/lib/site";

export const Route = createFileRoute("/community")({
  head: () => ({
    meta: [
      { title: "Community · KAfrequency" },
      { name: "description", content: "Do not only follow the frequency. Enter it. Free membership and future paid tiers from KAfrequency." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Community · KAfrequency" },
      { property: "og:description", content: "Do not only follow the frequency. Enter it." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: absoluteUrl("/community") },
      { property: "og:site_name", content: "Buddha KA · KAfrequency" },
    ],
    links: [{ rel: "canonical", href: absoluteUrl("/community") }],
  }),
  component: Community,
});

function Community() {
  const tiers = [
    { name: "Listener", price: "Free", desc: "Newsletter, updates, and public transmissions.", features: ["Email transmissions", "Public releases", "Public activations"] },
    { name: "Frequency Member", price: "$14.99/mo", desc: "For those actively building interior architecture.", features: ["Early access to music", "Private activations", "Unreleased tracks", "Creative notes"], featured: true },
    { name: "Inner Circle", price: "$49.99/mo", desc: "For the disciplined field. A private room.", features: ["Everything in Frequency Member", "Downloads", "Announcements before public", "Live sessions"] },
  ];
  return (
    <>
      <section className="relative border-b hairline">
        <div className="absolute inset-0 -z-10 halo opacity-40" aria-hidden />
        <div className="mx-auto max-w-4xl px-4 py-20 text-center sm:px-6 sm:py-28">
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Community</p>
          <h1 className="mt-4 font-serif text-5xl sm:text-6xl md:text-7xl">Do not only follow the frequency.</h1>
          <p className="mt-4 font-serif text-3xl italic text-gold-luminous">Enter it.</p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
        <div className="grid gap-6 md:grid-cols-3">
          {tiers.map((t) => (
            <div key={t.name} className={`rounded-2xl border p-8 ${t.featured ? "border-gold bg-charcoal shadow-gold" : "hairline bg-charcoal"}`}>
              {t.featured && <p className="mb-2 text-[10px] uppercase tracking-[0.3em] text-gold">Signature</p>}
              <p className="font-serif text-2xl text-gold-luminous">{t.name}</p>
              <p className="mt-2 text-3xl font-serif">{t.price}</p>
              <p className="mt-3 text-sm text-muted-foreground">{t.desc}</p>
              <ul className="mt-6 space-y-2 text-sm">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-2">
                    <span className="mt-1 text-gold">◆</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Link
                to={t.price === "Free" ? "/newsletter" : "/membership"}
                className="mt-8 block w-full rounded-full border border-gold px-4 py-3 text-center text-sm text-gold hover:bg-gold hover:text-obsidian"
              >
                {t.featured ? "Join the Frequency" : t.price === "Free" ? "Subscribe free" : "Enter"}
              </Link>
            </div>
          ))}
        </div>
        <p className="mt-10 text-center text-xs text-muted-foreground">
          Paid memberships are live on the <Link to="/membership" className="text-gold underline decoration-gold/40 underline-offset-4 hover:text-gold-luminous hover:decoration-gold">membership page</Link>. Free listener tier opens with the newsletter.
        </p>
        <div className="mt-8 text-center">
          <Link to="/plan" className="text-sm text-gold hover:text-gold-luminous">View roadmap →</Link>
        </div>
      </section>
    </>
  );
}
